import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChange,
} from '@angular/core';
import { NavController, NavParams, App, Events } from 'ionic-angular';
import { MatchmakingProvider } from '../../providers/matchmaking/matchmaking';
import { CurrentEventProvider } from '../../providers/current-event/current-event';
import { User } from '../../providers/user/user';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
/**
 * Generated class for the MatchmakingPicksComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'matchmaking-contacts',
  templateUrl: 'matchmaking-contacts.html',
})
export class MatchmakingContactsComponent implements OnInit {
  contacts: any[] = [];
  eventId: string = '';
  eventPin: number;
  showInvisibeMsg: boolean = false;
  showNoContactsMsg: boolean = false;

  page = 0;
  pageSize = 20;
  totalPages: number = 0;

  @Input('search') search: string = '';
  @Input('refresh') refresh;

  constructor(
    public events: Events,
    private app: App,
    private navCtrl: NavController,
    private navParams: NavParams,
    private matchmakingProvider: MatchmakingProvider,
    private currentEventProvider: CurrentEventProvider,
    private userProvider: User,
    private analyticsProvider: AnalyticsProvider
  ) {
    events.subscribe('user:removed', () => {
      this.getContacts(this.eventId, '');
    });
  }

  ngOnInit(): void {
    this.currentEventProvider.currentEvent.subscribe(event => {
      if (this.eventId !== event.uuid) {
        this.getContacts(event.uuid, '');
        this.eventPin = event.pin;
        this.eventId = event.uuid;

        // track page view
        this.analyticsProvider.trackScreenView('Matchmaking - Contacts', event.pin, event.name);
      }
    });
  }
  ngOnChanges(changes: SimpleChange) {
    if (changes['refresh'] !== undefined || changes['search'] !== undefined) {
      if (this.eventId) {
        this.page = 0;
        this.contacts = [];
        this.getContacts(this.eventId, this.search);
      }
    }
  }

  getContacts(eventId: string, query: string): void {
    this.matchmakingProvider
      .searchEventContactsPaginated(
        eventId,
        this.search,
        this.page,
        this.pageSize
      )
      .subscribe((response: any) => {
        if (response.data.length > 0) {
          this.showInvisibeMsg = false;
          this.contacts = response.data;
          this.totalPages = response.totalPages;
        } else {
          this.matchmakingProvider
            .checkUserStatus(this.eventPin)
            .subscribe(res => {
              this.showInvisibeMsg = res.visible ? false : true;
            });
        }
        this.showNoContactsMsg = this.contacts.length === 0 ? true : false;
      });
  }

  viewMessages(userId: string): void {
    this.app.getRootNav().push('MessagePage', {
      userId: userId,
    });
  }

  viewProfile(userId: string): void {
    if ( userId !== this.userProvider.currentUser().uuid) {
      this.app.getRootNav().push('ProfilePage', {
        userId: userId,
        event: this.eventId,
      });
    }
  }

  addNote(contact: any): void {
    console.dir(
      'ovo je contact u trenutku poziva sa picka sa dir ' + contact.uuid
    );
    this.app.getRootNav().push('NotePage', {
      user: contact,
    });
  }

  sendContactRequest(userId: string): void {
    this.app.getRootNav().push('SendContactRequestPage', {
      userId: userId,
    });
  }

  doInfinite(infiniteScroll) {
    this.page++;
    setTimeout(() => {
      this.matchmakingProvider
        .searchEventContactsPaginated(
          this.eventId,
          this.search,
          this.page,
          this.pageSize
        )
        .subscribe(res => {
          this.contacts.push(...res.data);
          this.totalPages = res.totalPages;

          infiniteScroll.complete();
        });
    }, 0);
  }

  shortTitle(element): number {
    let height = element.offsetHeight;
    return height;
  }
  profileOnEvent() {
    this.app.getRootNav().push('MatchmakingProfileSettingsPage', {});
  }

  findMatch(): void {
    this.events.publish('segment', 'all');
    this.currentEventProvider.setCurrentSegment('all');
  }

}



// WEBPACK FOOTER //
// ./src/components/matchmaking-contacts/matchmaking-contacts.ts